import { LayoutDashboard, Users, Shield, AppWindow } from "lucide-react";
import { AdminShell, AdminForbiddenPage } from "@trillion/auth";
import type { NavItem } from "@trillion/ui/components/app-sidebar";
import { RootLayout } from "../layouts/root-layout";
import { LoginPage } from "../pages/login";
import { DashboardPage } from "../pages/dashboard";
import { UsersPage } from "../pages/users";
import { UserInvitePage } from "../pages/user-invite";
import { UserDetailPage } from "../pages/user-detail";
import { ApplicationsPage } from "../pages/applications";

const navItems: NavItem[] = [
  { label: "Dashboard", href: "/", icon: LayoutDashboard },
  { label: "Users", href: "/users", icon: Users },
  { label: "Applications", href: "/applications", icon: AppWindow },
];

export const routes = [
  {
    element: <RootLayout />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/forbidden", element: <AdminForbiddenPage /> },
      {
        element: (
          <AdminShell
            appName="Passport Admin"
            navItems={navItems}
            product="passport"
            logo={<Shield className="size-5 text-primary" />}
          />
        ),
        children: [
          { index: true, element: <DashboardPage /> },
          { path: "/users", element: <UsersPage /> },
          { path: "/users/invite", element: <UserInvitePage /> },
          { path: "/users/:userId", element: <UserDetailPage /> },
          { path: "/applications", element: <ApplicationsPage /> },
        ],
      },
    ],
  },
];
